import React from 'react'
import FormRegister from './components.ts/FormRegister'

const VpaPool = () => {
  return (
    <div><FormRegister/></div>
  )
}

export default VpaPool